import { useQuery } from 'react-query';
import { getPatientNutrients } from '../api/getPatientNutrients';
import { getNutrientProfile } from '../helpers/dietIdHelpers';

const getNutrientProfileData = (nutrientsData) => {
  const keysToFind = [
    'energy-kilocalories',
    'total-carbohydrate',
    'total-fat',
    'total-saturated-fatty-acids-sfa',
    'sodium',
    'total-protein',
    'total-dietary-fiber',
    'added-sugars-by-total-sugars',
    'net-available-carbs',
  ];

  // Return an ordered array instead of an object
  let orderedNutrients = [];

  if (nutrientsData?.diet_id_nutrition_info) {
    orderedNutrients = getNutrientProfile(nutrientsData.diet_id_nutrition_info);
  }
  return orderedNutrients;
};

const usePatientNutrients = (workflowToken) => {
  const { data, isLoading, refetch } = useQuery(
    'nutrients ' + workflowToken,
    () => getPatientNutrients(workflowToken),
    {
      refetchOnWindowFocus: false,
      staleTime: 1000,
    },
  );
  const nutrientProfile = getNutrientProfileData(data);
  return { data: nutrientProfile, isLoading, refetch };
};

export default usePatientNutrients;
